import { z } from 'zod';

/**
 * The one unauthenticated route. It exists so a deploy can prove the Lambda
 * answers before anything harder is attempted, so it deliberately touches no
 * database - a health check that fails when the cluster is resuming would fail
 * every morning.
 */
export const healthResponseSchema = z
  .object({
    status: z.literal('ok'),
    /** The git sha the Lambda was built from, or 'unknown' outside CI. */
    commit: z.string(),
    /** When this container started, not when the request arrived. */
    startedAt: z.string(),
  })
  .readonly();

export type HealthResponse = z.infer<typeof healthResponseSchema>;
